module.exports = __webpack_public_path__ + "static/media/Andy---Pastels.9283287b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Andy---Pastels.jpg
 ** module id = 417
 ** module chunks = 0
 **/